/**
 * Bond interest rate settings
 * Rates are stored as percentages (3.0 = 3.0%, not 0.03)
 */
export interface BondInterestRateSettings {
  /** Starting interest rate (e.g., 3.0 for 3.0%) */
  startRate: number;

  /** Increment per payment period (e.g., 0.05 for 0.05%) */
  incrementRate: number;

  /** Maximum interest rate (e.g., 5.0 for 5.0%) */
  maxRate: number;
}

/**
 * App-level settings (persisted in localStorage)
 */
export interface AppSettings {
  /** Bond interest rate baseline */
  bondInterestRates: BondInterestRateSettings;

  // Future: Other app-level settings
}

/**
 * Default app settings
 */
export const DEFAULT_APP_SETTINGS: AppSettings = {
  bondInterestRates: {
    startRate: 3.0,
    incrementRate: 0.05,
    maxRate: 5.0,
  },
};

/**
 * Validation constants for bond interest rates
 */
export const BOND_RATE_CONSTRAINTS = {
  MIN_RATE: 0,
  MAX_RATE: 15,
  STEP: 0.001, // Allow up to 3 decimal places (0.001%)
  DECIMAL_PLACES: 3,
} as const;
